import React from "react";
import { Link } from "../../../shims/useNavigate";
import { KeyValuePair } from "../../../types/types";
import EpcPieChart from "./EpcPieChart/EpcPieChart";
import Button from "../../UI/Button/Button";

import "./EpcDataSummary.scss";

interface EpcDataSummaryProps {
	data: KeyValuePair;
}

export default function EpcDataSummary({ data }: EpcDataSummaryProps) {
	return (
		<div>
			<div className="epc-pie-chart">
				<EpcPieChart data={data} />
			</div>
			<div className="epc-pie-chart-button">
				<Link to="/epc-data">
					<Button variant="contained">View Data</Button>
				</Link>
				<Link to="/mapping" target="_BLANK">
					<Button variant="outlined">View Mapping</Button>
				</Link>
			</div>
		</div>
	);
}
